/**
 * AuroraBackground — layered gray-tone ambiance.
 *
 * A diagonal graphite gradient (charcoal in dark mode, soft gray in light)
 * with two subtle radial glows and a bottom vignette. All tones come from
 * the theme tokens (--app-bg-*, --bg-glow, --bg-shade) so the surface
 * inverts cleanly between modes. Glass surfaces frost against this depth.
 *
 * Non-interactive (`pointer-events-none`, `aria-hidden`).
 */
export function AuroraBackground() {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 -z-10 overflow-hidden pointer-events-none"
    >
      {/* Base — diagonal gray gradient */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(165deg, hsl(var(--app-bg-from)) 0%, hsl(var(--app-bg-via)) 45%, hsl(var(--app-bg-to)) 100%)',
        }}
      />

      {/* Primary glow — soft sheen from the top-left */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 80% 55% at 28% -8%, hsl(var(--bg-glow)) 0%, transparent 60%)',
        }}
      />

      {/* Secondary glow — faint highlight on the right edge */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 45% 35% at 92% 22%, hsl(var(--bg-glow)) 0%, transparent 70%)',
          opacity: 0.5,
        }}
      />

      {/* Bottom vignette — grounds the layout */}
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(to bottom, transparent 55%, hsl(var(--bg-shade)) 100%)',
        }}
      />

      {/* Fractal noise texture — eliminates banding on OLED */}
      <svg
        className="absolute inset-0 h-full w-full opacity-[0.035] mix-blend-overlay"
        xmlns="http://www.w3.org/2000/svg"
      >
        <filter id="aurora-noise">
          <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" stitchTiles="stitch" />
          <feColorMatrix type="saturate" values="0" />
        </filter>
        <rect width="100%" height="100%" filter="url(#aurora-noise)" />
      </svg>
    </div>
  );
}
